/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Calc_Row_KbInputs */

const en_mk_calc_row_kb = /** @type {(inputs: Mk_Calc_Row_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng — Team plan`)
};

const id_mk_calc_row_kb = /** @type {(inputs: Mk_Calc_Row_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng — paket Tim`)
};

/**
* | output |
* | --- |
* | "KerjaBareng — Team plan" |
*
* @param {Mk_Calc_Row_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_calc_row_kb = /** @type {((inputs?: Mk_Calc_Row_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Calc_Row_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_calc_row_kb(inputs)
	return en_mk_calc_row_kb(inputs)
});